import React, {Fragment} from 'react'
import Header from '../components/Header'
import Hero from '../components/AboutUs/Hero'
import Team from '../components/AboutUs/Team'
import Footer from '../components/Footer'

class AboutUs extends React.Component{
    constructor(props){
        super(props)
    }

    render(){
        return(
            <Fragment>
                <Header logoColor="#46e2b9" classStatic="" dropDownColor="black"/>
                <Hero/>
                <Team />
                <Footer/>
            </Fragment>
        )
    }
}

export default AboutUs;